module.exports = "img/flags/AW.f35b876.png";